export default {
      id: "icon-linkedin-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-linkedin",
      toString: function () {
        return this.url;
      }
    }